import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import defaultFilter, { DefaultFilterState } from './default-filters/default-filter.store';
import targetGroupFilter, { TargetGroupFilterState } from './target-group-filters/target-group-filter.store';
import { Team } from './team.interface';
import { TeamService } from './team.service';
import videocallRoom, { VideocallRoomState } from './videocall-rooms/videocall-room.store';

const service = new TeamService();

export interface TeamState {
   teams: Array<Team>;

   videocallRoom?: VideocallRoomState;
   defaultFilter?: DefaultFilterState;
   targetGroupFilter?: TargetGroupFilterState;
}

const TeamStore: Module<TeamState, StoreState> = {
   namespaced: true,
   state: {
      teams: [],
   },
   getters: {},
   mutations: {
      SET_TEAMS(state, teams: Array<Team>) {
         state.teams = teams;
      },
   },
   actions: {
      async searchTeams(context, query: LocationQuery) {
         const response = await service.getSearchTeams({ ...query, page: '1' });
         return response.data;
      },
      async getTeams(context, query: LocationQuery) {
         const response = await service.getTeams(query);
         return response;
      },
      async updateIncomingMessagesTeam(context, teamId: number) {
         const response = await service.updateIncomingMessagesTeam(teamId);
         return response;
      },
   },
   modules: {
      videocallRoom,
      defaultFilter,
      targetGroupFilter,
   },
};

export default TeamStore;
